import { transformUoms } from "services/utility/afterGet";
import { transformJobWorkCenter } from "services/utility/jobWorkCenter";

export function inventoryTransactionAfterGet(record) {
  const newRecord = { ...record };

  newRecord.number = record.number === "auto" ? "" : record.number;

  // date can be null on a "populateFrom" API call
  if (!newRecord.date) {
    newRecord.date = new Date();
  }

  // line items
  const newLines = [];
  record.lines.forEach((line) => {
    const newLine = { ...line };

    newLine.jobWorkcenter = transformJobWorkCenter(line.job, line.workcenter);

    if (line.itemDetails) {
      newLine.itemDetails.itemUoms = transformUoms(line.itemDetails.itemUoms);
    }

    // add property for related records
    newLine.relatedRecords = {};

    // and add this line to the collection of new lines
    newLines.push(newLine);
  });
  // update the record with the new lines
  newRecord.lines = newLines;
  return newRecord;
}
